
export const joinByComma = <T,>(list: T[] | undefined | null, map: (item: T) => string | undefined | null): string => {
    if (!Array.isArray(list) || list.length === 0) return ''
    return list
        .map(map)
        .filter(Boolean)
        .join(', ')
}


// WEBPACK FOOTER //
// ./src/utils/ArrayUtils.ts